document.documentElement.classList.remove('no-js');

const showToast = (message) => {
  const toast = document.querySelector('.ws-toast');
  if (!toast) return;
  toast.textContent = message;
  toast.hidden = false;
  clearTimeout(showToast.timer);
  showToast.timer = setTimeout(() => { toast.hidden = true; }, 2400);
};

const menu = document.querySelector('[data-mobile-menu]');
const setMenu = (open) => {
  if (!menu) return;
  menu.hidden = !open;
  document.body.classList.toggle('ws-locked', open);
};
document.querySelector('[data-menu-open]')?.addEventListener('click', () => setMenu(true));
document.querySelector('[data-menu-close]')?.addEventListener('click', () => setMenu(false));
document.addEventListener('keydown', (event) => { if (event.key === 'Escape') setMenu(false); });

document.querySelector('[data-sort-by]')?.addEventListener('change', (event) => {
  const url = new URL(window.location.href);
  url.searchParams.set('sort_by', event.target.value);
  window.location.assign(url.toString());
});

document.querySelectorAll('[data-product-root]').forEach((root) => {
  const variantsNode = root.querySelector('[data-product-variants]');
  const variantInput = root.querySelector('[data-variant-id]');
  const price = root.querySelector('[data-product-price]');
  const addButton = root.querySelector('[data-add-to-cart]');
  const form = root.querySelector('[data-product-form]');
  if (!variantsNode || !variantInput || !addButton || !form) return;
  const variants = JSON.parse(variantsNode.textContent || '[]');

  const updateVariant = () => {
    const options = [...root.querySelectorAll('.ws-option')].map((group) => group.querySelector('input:checked')?.value);
    const variant = variants.find((item) => item.options.every((value, index) => value === options[index]));
    if (!variant) {
      variantInput.value = '';
      addButton.disabled = true;
      addButton.textContent = 'Unavailable';
      return;
    }
    variantInput.value = variant.id;
    addButton.disabled = !variant.available;
    addButton.textContent = variant.available ? 'Add to bag' : 'Sold out';
    if (price && window.Shopify?.currency?.active) {
      price.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en-IN', { style: 'currency', currency: window.Shopify.currency.active }).format(variant.price / 100);
    }
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url.toString());
  };

  root.querySelectorAll('.ws-option input').forEach((input) => input.addEventListener('change', updateVariant));
  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    if (!variantInput.value) return;
    addButton.disabled = true;
    try {
      const rootUrl = window.WowStreeRoutes?.root || '/';
      const response = await fetch(rootUrl + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(variantInput.value), quantity: 1 }] }) });
      if (!response.ok) throw new Error('Could not add this item.');
      const cart = await fetch(rootUrl + 'cart.js').then((result) => result.json());
      document.querySelectorAll('.ws-count').forEach((count) => { count.textContent = cart.item_count; });
      showToast('Added to your bag');
    } catch (error) {
      showToast(error.message || 'Please try again.');
    } finally {
      updateVariant();
    }
  });
});

document.querySelectorAll('product-recommendations').forEach(async (element) => {
  if (!element.dataset.url) return;
  try {
    const html = await fetch(element.dataset.url).then((response) => response.text());
    const documentFragment = new DOMParser().parseFromString(html, 'text/html');
    const recommendations = documentFragment.querySelector('product-recommendations');
    if (recommendations?.innerHTML.trim()) element.innerHTML = recommendations.innerHTML;
  } catch (_) {}
});
